import * as React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';
import { rem, rgba } from 'polished';
import {
  FlexRowCenter,
  FlexColCenterHorizontal,
} from '../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../Defaults/Text';
import {
  generateUrlFromString,
  resolveCategoryUrl,
} from '../../../utilities/selectors';
import { IconType, SvgIcon } from '../General/SvgIcon';
import { prop } from '../../../utilities';

export interface Props {
  id: number;
  index: number;
  name: string;
  imgSrc: string;
  bigImgSrc: string;
  url: string;
  onMouseOver?: any;
  firstLevel: boolean;
  numOfCat?: number;
  onClick: any;
  active?: boolean;
  lastItem?: boolean;
}

function NavigationSanitasDropdownItem({
  id,
  index,
  name,
  imgSrc,
  bigImgSrc,
  url,
  onMouseOver,
  firstLevel,
  numOfCat,
  onClick,
  active = false,
  lastItem = false,
}: Props) {
  let isCurrent = false;
  if (window && window.location) {
    isCurrent = prop(window.location, 'pathname').includes(
      generateUrlFromString(url),
    );
  }

  return (
    <Wrapper
      className={active ? 'activeItem' : ''}
      onClick={onClick}
      to={resolveCategoryUrl(id, url)}
      firstLevel={firstLevel}
      // tslint:disable-next-line:jsx-no-lambda
      onMouseOver={onMouseOver ? () => onMouseOver(index) : null}
      lastItem={lastItem}
    >
      <ImageWrapper>
        <Image alt={`Obrázok ku kategórií ${name}`} src={imgSrc} />
      </ImageWrapper>
      {bigImgSrc && (
        <BigImageWrapper>
          <BigImage
            alt={`Zväčšený obrázok ku kategórií ${name}`}
            src={bigImgSrc}
          />
          <BigImageName>{name}</BigImageName>
        </BigImageWrapper>
      )}
      <Name isCurrent={isCurrent} className="categoryName">
        {name}
      </Name>
      {numOfCat && numOfCat > 0 ? (
        <StyledSvgIcon
          icon={IconType.rightArrow}
          width={20}
          height={20}
          marginRight={0}
          fill={'#3962A8'}
          cursor="pointer"
          viewBox="0 0 20 20"
        />
      ) : null}
    </Wrapper>
  );
}

const StyledSvgIcon = styled(SvgIcon)`
  position: absolute;
  right: ${rem(16)};
  width: ${rem(16)};
  height: ${rem(15)};
`;

// const Wrapper = styled.a<{ firstLevel: boolean }>`
const Wrapper = styled(Link)`
  position: relative;
  text-decoration: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  padding: ${rem(16)};
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  color: };
  font-size: ${rem(16)};
  line-height: ${rem(21)};
  min-height: ${rem(64)};
  max-height: ${rem(64)};
  border-bottom: ${(props: { lastItem: boolean; theme: any }) =>
    props.lastItem ? '' : '1px solid ' + rgba('#003463', 0.08)};

  &.activeItem {
    background-color: #28529A;
    ${StyledSvgIcon} {
      fill: white;
    }
  }

  &.activeItem > p.categoryName {
    color: ${({ theme }) => theme.colors.white};
  }

  &:hover {
    ${StyledSvgIcon} {
      fill: white;
    }
    background-color: #28529A;
  }

  &:hover > p.categoryName {
    color: ${({ theme }) => theme.colors.white};
    text-decoration: underline;
  }

`;

const ImageWrapper = styled(FlexRowCenter)`
  width: ${rem(32)};
  height: ${rem(32)};
  padding: ${rem(4)};
  margin-right: ${rem(16)};
  border-radius: ${rem(4)};
  background-color: ${({ theme }) => theme.colors.white};
`;

const BigImageName = styled(TextP)`
  text-align: center;
  margin: ${rem(16)} 0;
  text-transform: lowercase;
`;

const BigImageWrapper = styled(FlexColCenterHorizontal)`
  position: absolute;
  width: ${rem(300)};
  height: ${rem(356)};
  display: none;
  margin-top: ${rem(170)};
  margin-left: ${rem(40)};
  pointer-events: none;
  border-radius: ${rem(8)};
  background-color: white;
  position: fixed;
  left: 50%;
  top: 50%;
  margin: 0;
  transform: translate(-50%, -50%);
  box-shadow: ${({ theme }) => theme.boxShadow.secondary};
  z-index: 113;
  ${ImageWrapper}:hover ~ & {
    display: block;
  }
`;

const BigImage = styled.img`
  /* position: absolute;
  width: ${rem(300)};
  height: ${rem(300)};
  display: none;
  margin-top: ${rem(170)};
  margin-left: ${rem(40)};
  pointer-events: none;
  border-radius: ${rem(8)};
  background-color: white; */

  /* position: fixed;
  left: 50%;
  top: 50%;
  margin: 0;
  transform: translate(-50%, -50%);
  box-shadow: ${({ theme }) => theme.boxShadow.secondary};
  z-index: 100; */

  ${ImageWrapper}:hover ~ & {
    display: block;
  }
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
`;

const Name = styled(TextP)`
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  color: #003463;
  max-width: ${rem(220)};
  font-size: ${rem(16)};
  letter-spacing: ${rem(24)}
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-transform: lowercase !important;
  :first-letter {
    text-transform: uppercase;
  }
  text-decoration: ${(props: { isCurrent: boolean }) =>
    props.isCurrent ? 'underline' : 'none'};
`;

function areEqual(prev: Props, next: Props) {
  return (
    prev.url === next.url &&
    prev.name === next.name &&
    prev.active === next.active
  );
}
const WithThemeNavigationDropdownItem: any = React.memo(
  NavigationSanitasDropdownItem,
  areEqual,
);
export { WithThemeNavigationDropdownItem as NavigationSanitasDropdownItem };
